export class StatusIndicator {
  expressions: Expression[] = [];
  postTime: number = -1;
  preTime: number = -1;
}

export class Expression {
  correlation: string = '';
  signal: string = '';
  signalLabel: string = '';
  operator: string = '';
  value: string = '';
}